var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerraLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 549.985,
    height: 578.225,
    viewBox: "0 0 549.985 578.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6309",
    "data-name": "Group 6309",
    transform: "translate(-1166.999 -251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M192.425,235.766c-.016-.009-.028-.01-.047-.019l-.108-.009a.322.322,0,0,0-.276.143L97.918,346.356a.366.366,0,0,0-.077.377.357.357,0,0,0,.277.256L202.287,374.9a.407.407,0,0,0,.365-.085.36.36,0,0,0,.131-.323l-10.1-138.384a.342.342,0,0,0-.26-.344",
    transform: "translate(1239.787 426.412)",
    fill: "#5b8f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M367.035,169.437a.552.552,0,0,0-.094.007L245.689,194.158a.353.353,0,0,0-.3.27.357.357,0,0,0,.124.412l1.352,1.142,92.188,77.564a.35.35,0,0,0,.366.065.344.344,0,0,0,.255-.265l27.71-103.413a.344.344,0,0,0-.089-.363.34.34,0,0,0-.262-.133",
    transform: "translate(1349.582 377.078)",
    fill: "#426b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M148.506,181.227a.819.819,0,0,1-.814.82L51.549,290.214a.33.33,0,0,0-.056.439.337.337,0,0,0,.429.208l174.005-34.953a.4.4,0,0,0,.316-.417l-6.122-83.928a.417.417,0,0,0-.4-.366l-.56.033-65.44,4.2a.39.39,0,0,0-.267.133l-4.95,5.569Z",
    transform: "translate(1205.271 378.387)",
    fill: "#bed600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M259.453,194l76.289,12.108a.346.346,0,0,0,.363-.131.374.374,0,0,0,.084-.359L308.432,102.047a.358.358,0,0,0-.251-.267.421.421,0,0,0-.4.084l-1.076.945L269.48,135.344a.4.4,0,0,0-.124.215l-10.227,57.984a.411.411,0,0,0,.07.305.4.4,0,0,0,.255.153",
    transform: "translate(1359.813 326.721)",
    fill: "#497d23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M264.578,183.956H205.646a.379.379,0,0,0-.3.136L166.362,229.88a.4.4,0,0,0,.023.544l116.18,112.32a.349.349,0,0,0,.455.066.331.331,0,0,0,.209-.4L264.974,184.3a.4.4,0,0,0-.4-.347",
    transform: "translate(1290.719 387.881)",
    fill: "#5b8f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M211.289,91.7h0L265.3,111.349l62.646,14.019a.564.564,0,0,1,.119.042c.084.016.192-.012.312-.234a.334.334,0,0,0-.066-.473L255.947,52.346a.392.392,0,0,0-.274-.117.416.416,0,0,0-.269.106L211.157,91.042a.36.36,0,0,0-.122.371.368.368,0,0,0,.255.286",
    transform: "translate(1324.023 289.863)",
    fill: "#00b9e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M161.751,126.748h.024a.364.364,0,0,0,.309-.2l25.248-43.728a.354.354,0,0,0-.009-.412.3.3,0,0,0-.31-.181L134.1,86.663a.338.338,0,0,0-.312.22.357.357,0,0,0,.024.4l27.607,39.291a.341.341,0,0,0,.335.173",
    transform: "translate(1266.512 312.184)",
    fill: "#00b9e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M.388,201.46a.454.454,0,0,1,.07-.005h.01l127.293-8.173a.355.355,0,0,0,.342-.255.361.361,0,0,0-.094-.42L28.48,96.985a.319.319,0,0,0-.249-.115.617.617,0,0,0-.153.023.348.348,0,0,0-.249.272L.016,200.961a.364.364,0,0,0,.075.354c.131.16.2.153.3.145",
    transform: "translate(1167 323.08)",
    fill: "#a1dee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M175.444,120.147l0,0a.343.343,0,0,0,.338.044l49.988-18.2a.374.374,0,0,0,.248-.26.359.359,0,0,0-.075-.359L173.382,38.049c-.11-.138-.174-.148-.255-.148a.747.747,0,0,0-.223.044c-.131.054-.218.133-.211.366l2.573,81.521a.4.4,0,0,0,.178.316",
    transform: "translate(1295.5 279.201)",
    fill: "#00b9e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M35.127,113.1a.256.256,0,0,1,.051,0h0l118.368-9.945a.361.361,0,0,0,.321-.223.367.367,0,0,0-.033-.4L109.08,38.838a.35.35,0,0,0-.288-.169.387.387,0,0,0-.317.12L34.839,112.422a.342.342,0,0,0-.082.436c.1.225.2.244.37.239",
    transform: "translate(1192.83 279.773)",
    fill: "#0cc6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M126.915,182.486a.366.366,0,0,0,.365.221l57.5-3.689a.371.371,0,0,0,.274-.15.377.377,0,0,0,.082-.328l-8.975-50.875a.336.336,0,0,0-.265-.3.366.366,0,0,0-.415.115L126.971,182.05a.337.337,0,0,0-.07.408l.014.028",
    transform: "translate(1261.396 345.752)",
    fill: "#0cc6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M271.6,162.3a.409.409,0,0,0-.262.1L235.45,192.517a.32.32,0,0,0-.106.473c.106.222.187.262.434.218l98.807-20.143c.265-.056.323-.129.319-.4s-.07-.331-.331-.375Z",
    transform: "translate(1342.074 371.766)",
    fill: "#427730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M231.587,182.314a.386.386,0,0,0-.235-.059.807.807,0,0,0-.242.037.35.35,0,0,0-.159.37L248.8,337.229a.4.4,0,0,0,.675.227l75.776-75.779a.38.38,0,0,0,.115-.289.36.36,0,0,0-.133-.279Z",
    transform: "translate(1338.848 386.615)",
    fill: "#427730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M186.855,240.1a.539.539,0,0,0-.417-.176L15.863,274.185a.393.393,0,0,0-.2.668L92.03,351.22a.342.342,0,0,0,.253.113.382.382,0,0,0,.319-.136l94.213-110.633a.343.343,0,0,0,.04-.466Z",
    transform: "translate(1178.564 429.523)",
    fill: "#58a618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M245.932,91.346a.361.361,0,0,0-.038.452l25.214,43.677a.376.376,0,0,0,.281.192.342.342,0,0,0,.312-.092l34.655-30.285a.339.339,0,0,0,.115-.391.346.346,0,0,0-.293-.284L246.2,91.2a.364.364,0,0,0-.267.148",
    transform: "translate(1349.922 318.859)",
    fill: "#426b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M179.219,251.808a.309.309,0,0,0-.237-.117.517.517,0,0,0-.2.044.35.35,0,0,0-.234.387l10.1,138.453a.361.361,0,0,0,.159.284.352.352,0,0,0,.333.066L293.37,363a.393.393,0,0,0,.173-.661Z",
    transform: "translate(1299.859 438.283)",
    fill: "#427730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M153.244,199.676v0l3.319,3.188a.586.586,0,0,0,.188.136.4.4,0,0,1,.126-.024.357.357,0,0,0,.251-.127l55.541-62.488a.389.389,0,0,0,.028-.487l-32.039-45.6a.418.418,0,0,0-.321-.167l-4.645.385L55.24,104.608a.394.394,0,0,0-.239.675Z",
    transform: "translate(1207.832 321.021)",
    fill: "#65cfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M229.579,80.168l.016.019a.391.391,0,0,0,.277.143.32.32,0,0,0,.277-.085l43.44-38.009a.387.387,0,0,0-.154-.673l-96.41-25.835a.42.42,0,0,0-.44.173.329.329,0,0,0,.033.457Z",
    transform: "translate(1298.34 262.691)",
    fill: "#00add0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M168.177,234.393a.723.723,0,0,1,.077.033.34.34,0,0,0,.335-.148l33.734-39.612a.415.415,0,0,0,.1-.291.383.383,0,0,0-.138-.269l-39.01-32.73a.325.325,0,0,0-.227-.1.585.585,0,0,0-.218.056.342.342,0,0,0-.2.375l5.278,72.342a.341.341,0,0,0,.269.344l.007,0",
    transform: "translate(1288.008 371.004)",
    fill: "#58a618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M143.279,158.376,15.934,166.549a.364.364,0,0,0-.29.16.368.368,0,0,0-.066.335L43.4,270.886a.351.351,0,0,0,.293.279.339.339,0,0,0,.38-.12L143.64,159.03a.349.349,0,0,0,.068-.415l.429-.228-.44.215a.42.42,0,0,0-.419-.225",
    transform: "translate(1178.58 368.848)",
    fill: "#eadf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M140.615,95.538l0,0a.463.463,0,0,0,.392.166l61.239-5.143a.392.392,0,0,0,.359-.4L199.773.378a.382.382,0,0,0-.155-.3A.379.379,0,0,0,199.383,0L93.973,28.232a.4.4,0,0,0-.218.61Z",
    transform: "translate(1236.705 251)",
    fill: "#00add0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraLogo);
export default __webpack_public_path__ + "static/media/terra_logo.2f6575d3fe16b35952a5808a2a50a006.svg";
export { ForwardRef as ReactComponent };